export default (theme) => ({
  poweredBy: {
    margin: '20px auto',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.background.default,
    userSelect: 'none',
    position: 'relative',
    zIndex: 1000,
  },
  poweredLogo: {
    width: 100,
    marginLeft: 5,
  },
});
